import './index.css'

import * as React from 'react'
import * as ReactDOM from 'react-dom'
import * as moment from 'moment'

import App from './App'
import { store } from './redux/store'

import { fetchAppConfig } from './redux/ui'
import { apiRequest } from './common/api/Request'

moment.locale('pl')
// break from iframe
// if (top.location !== self.location) {
//   top.location.href = self.location.href
// }

apiRequest.setDomain((window as any).API_URL)
store.dispatch(fetchAppConfig() as any)

// store.dispatch(setConfig(config))
// const token = apiRequest.getTokenFromStorage()

// import * as moment from 'moment'

// const date = moment(new Date()).format('YYYY-MM-DDTHH:MM:ss')
// console.log(date)

// if (token) {
//   apiRequest.setToken(token)
//   // https://medium.com/@peatiscoding/typescripts-with-redux-redux-thunk-recipe-fcce4ffca405
//   store.dispatch(checkTokenThunk(token) as any) //to przechodzi przez thunk wiec ta funkcja nie zwraca {type: "LOGIN"}
//   // poczekajmy i sprawdzmy czy token jest ok
// } else {
//   store.dispatch(logoutAction())
// }

const renderApp = () =>
  ReactDOM.render(<App />, document.getElementById('root') as HTMLElement)

renderApp()
